import React, { forwardRef, memo, useEffect, useContext, createContext, useState } from 'react';
import { motion } from 'framer-motion';
import { Box as Box$1, useThemeUI } from 'theme-ui';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Box = motion(Box$1);

var Block = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: "contentBlock"
  }, props, {
    __themeKey: "blocks",
    __css: {
      position: 'relative'
    }
  }));
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var shortenText = function shortenText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxchar = arguments.length > 1 ? arguments[1] : undefined;

  if (maxchar && text.length > maxchar) {
    return "".concat(text.slice(0, maxchar), "...");
  }

  return text;
};

var RichText = function RichText(_ref) {
  var Bold = _ref.Bold,
      Italic = _ref.Italic,
      content = _ref.content,
      maxchar = _ref.maxchar;
  var result = [];
  var position = 0; // return if content is string

  if (!content || !content.blocks) return shortenText(content, maxchar);
  var totalTextLength = 0;
  var isShortend = false; // shortenText if maxchar given

  var shortendContent = {
    blocks: []
  };

  if (maxchar) {
    content.blocks.forEach(function (block) {
      totalTextLength += block.text.length;

      if (isShortend) {
        return;
      }

      if (totalTextLength <= maxchar) {
        shortendContent.blocks.push(block);
      } else {
        // this might lead to
        var shortenBy = maxchar - totalTextLength; // eslint-disable-next-line no-param-reassign

        block.text = shortenText(block.text, shortenBy);
        shortendContent.blocks.push(block);
        isShortend = true;
      }
    });
  } else {
    shortendContent.blocks = content.blocks;
  } // if content is richText Object check for emphasized strings


  content.blocks.forEach(function (block, blockIndex) {
    if (block.inlineStyleRanges.length !== 0) {
      block.inlineStyleRanges.forEach(function (inlineStyle, inlineStyleIndex) {
        var start = inlineStyle.offset;
        var end = start + inlineStyle.length; // return everything between the last inlineStyle
        // and the new one as normal text

        result.push(block.text.slice(position, start));

        if (inlineStyle.style === 'BOLD') {
          result.push(
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement(Bold, {
            key: "".concat(block.key, "-").concat(inlineStyleIndex)
          }, block.text.slice(start, end)));
        } else if (inlineStyle.style === 'ITALIC') {
          result.push(
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement(Italic, {
            key: "".concat(block.key, "-").concat(inlineStyleIndex)
          }, block.text.slice(start, end)));
        } // keep track of where we are


        position = end;
      }); // return everything of the end of the string

      result.push(block.text.slice(position));
    } else {
      // if no inline Styling, just return the text
      result.push(block.text);
    } // between every block, add a break


    if (blockIndex < content.blocks.length) {
      result.push( /*#__PURE__*/React.createElement("br", {
        key: "".concat(block.key)
      }));
    }

    position = 0;
  });
  return result;
};
RichText.propTypes = {
  Bold: PropTypes.elementType,
  Italic: PropTypes.elementType
};
RichText.defaultProps = {
  Italic: React.Fragment,
  Bold: React.Fragment
};

var Emphasize = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: motion.span
  }, props, {
    __themeKey: "typography"
  }));
});

var _excluded$b = ["as", "variant", "boldVariant", "italicVariant", "type", "children"];
var Label = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _theme$typography;

  var as = _ref.as,
      variant = _ref.variant,
      boldVariant = _ref.boldVariant,
      italicVariant = _ref.italicVariant,
      type = _ref.type,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$b);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme; // allows us to only specify `type=loud`
  // but actually lookup loudLabel in typographySetup.js


  var fullType = theme !== null && theme !== void 0 && (_theme$typography = theme.typography) !== null && _theme$typography !== void 0 && _theme$typography[type] ? type : "".concat(type, "Label");
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: as || motion.label,
    variant: variant
  }, props, {
    __themeKey: "typography.".concat(fullType),
    __css: {
      color: 'labels',
      zIndex: 'inherit'
    }
  }), children && /*#__PURE__*/React.createElement(RichText, {
    content: children,
    Bold: function Bold(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Emphasize, {
        color: "labelBold",
        variant: boldVariant || "".concat(fullType, ".bold")
      }, children);
    },
    Italic: function Italic(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(Emphasize, {
        color: "labelItalic",
        variant: italicVariant || "".concat(fullType, ".italic")
      }, children);
    }
  }));
});
Label.propTypes = {
  as: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
  boldVariant: PropTypes.string,
  italicVariant: PropTypes.string,
  children: PropTypes.node
};
Label.defaultProps = {
  as: undefined,
  type: 'label',
  variant: 'normal',
  boldVariant: undefined,
  italicVariant: undefined,
  children: undefined
};

var Input = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: "input",
    as: motion.input
  }, props, {
    __themeKey: "forms",
    __css: {
      boxSizing: "border-box",
      display: "block",
      width: "100%",
      appearance: "none",
      border: "inherit"
    }
  }));
});

var GridItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: "gridColumnFallback"
  }, props, {
    __themeKey: "measure",
    __css: {
      position: 'relative'
    }
  }));
});

var _excluded$a = ["type", "label", "name", "placeholder", "required", "sx", "inputAs", "inputVariant"];
var FormField = function FormField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      label = _ref.label,
      name = _ref.name,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      sx = _ref.sx,
      _ref$inputAs = _ref.inputAs,
      inputAs = _ref$inputAs === void 0 ? undefined : _ref$inputAs,
      inputVariant = _ref.inputVariant,
      props = _objectWithoutProperties(_ref, _excluded$a);

  var inputProps = {}; // only add ass to input if inputAs is given (will break otherwise)

  if (inputAs) {
    inputProps.as = inputAs;
  }

  return /*#__PURE__*/React.createElement(GridItem, {
    sx: sx
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement(Input, _extends({
    variant: inputVariant,
    type: type,
    id: name,
    name: name,
    placeholder: placeholder,
    required: required
  }, inputProps, props)));
};
FormField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  sx: PropTypes.shape(),
  inputAs: PropTypes.string,
  inputVariant: PropTypes.string,
  required: PropTypes.bool
};
FormField.defaultProps = {
  type: "text",
  placeholder: "",
  sx: {},
  inputAs: undefined,
  inputVariant: undefined,
  required: false
};

var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: motion.button,
    variant: "primary",
    __themeKey: "buttons"
  }, props, {
    __css: {
      appearance: 'none',
      border: 'none',
      backgroundColor: 'inherit'
    }
  }));
});

var _excluded$9 = ["variant"];
var GridWrapper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded$9);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: variant
  }, props, {
    __themeKey: "grids",
    __css: {
      display: 'grid',
      position: 'relative'
    }
  }));
});
GridWrapper.propTypes = {
  variant: PropTypes.oneOf(['outside.columns', 'outside.autoColumns', 'outside.autoColumnsAndRows', 'inside.columns', 'inside.autoColumns', 'inside.autoColumnsAndRows'])
};
GridWrapper.defaultProps = {
  variant: 'outside.columns'
};

var FlexItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, props));
});

var FlexWrapper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, props, {
    __css: {
      display: 'flex'
    }
  }));
});

var _excluded$8 = ["as"];
var Section = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
      props = _objectWithoutProperties(_ref, _excluded$8);

  var motionElement = as ? motion[as] : motion.section;
  return /*#__PURE__*/React.createElement(GridWrapper, _extends({
    ref: ref
  }, props, {
    as: motionElement
  }));
});
Section.propTypes = {
  as: PropTypes.string
};
Section.defaultProps = {
  as: null
};

var Link = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: motion.a,
    variant: "hyperLink"
  }, props, {
    __themeKey: "links",
    __css: {
      color: 'inherit'
    }
  }));
});

var _excluded$7 = ["as", "type", "variant", "boldVariant", "italicVariant", "maxchar", "children"];
/*
// Props
// type: lookup key for the theme.
//       Can be either full themeKey e.g. `smallParagraph` or short version
//       without appended "Paragraph": e.g. `small`
// as: html element to use. Defaults to `p`.
// maxchar: Maximum number of chars to display.
//          Will cut off after specified numner and append `...`
// variant: Font variant as specified in fontFamilies.js
//          Defaults to `normal`. Could be e.g. `bold`,...
// boldVariant: Typography variant  to be used for the bold styling
//              defaults to '<type>.bold'
// italicVariant: Typography variant  to be used for the italic styling
//              defaults to '<type>.italic'
*/

var Heading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
      type = _ref.type,
      variant = _ref.variant,
      boldVariant = _ref.boldVariant,
      italicVariant = _ref.italicVariant,
      maxchar = _ref.maxchar,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: as ? motion[as] : motion[type],
    variant: variant
  }, props, {
    __themeKey: "typography.".concat(type),
    __css: {
      color: 'heading',
      zIndex: 'inherit'
    }
  }), children && /*#__PURE__*/React.createElement(RichText, {
    maxchar: maxchar,
    content: children,
    Bold: function Bold(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Emphasize, {
        color: "headingBold",
        variant: boldVariant || "".concat(type, ".bold")
      }, children);
    },
    Italic: function Italic(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(Emphasize, {
        color: "headingItalic",
        variant: italicVariant || "".concat(type, ".italic")
      }, children);
    }
  }));
});
Heading.propTypes = {
  as: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
  boldVariant: PropTypes.string,
  italicVariant: PropTypes.string,
  maxchar: PropTypes.string,
  children: PropTypes.node
};
Heading.defaultProps = {
  as: undefined,
  type: 'h1',
  variant: 'normal',
  boldVariant: undefined,
  italicVariant: undefined,
  maxchar: undefined,
  children: undefined
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var canUseDom = Boolean(typeof window !== 'undefined' && window.document);

var portalContainer;
var Portal = function Portal(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      el = _React$useState2[0],
      setEl = _React$useState2[1];

  if (!portalContainer && canUseDom) {
    portalContainer = document.createElement('div');
    portalContainer.setAttribute('portal-container', '');
    document.body.insertBefore(portalContainer, document.body.childNodes[0]);
  }

  React.useEffect(function () {
    // This fixes SSR
    var portalElement = document.createElement('div');
    setEl(portalElement);
    portalContainer.appendChild(portalElement);
    return function () {
      portalContainer.removeChild(portalElement);
    };
  }, []);
  if (!canUseDom || !el) return null;
  return /*#__PURE__*/ReactDOM.createPortal(children, el);
};
Portal.propTypes = {
  children: PropTypes.node.isRequired
};

function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }

  return undefined;
}

// Based on evergreens preventBodyScroll function
var previousOverflow;
var previousPaddingRight;
/**
 * Toggle the body scroll / overflow and additional styling
 * necessary to preserve scroll position and body width (scrollbar replacement)
 *
 * @param {boolean} preventScroll - whether or not to prevent body scrolling
 */

function preventBodyScroll(preventScroll) {
  /** Get the width before toggling the style so we can calculate the scrollbar width for a smooth, jankless style change */
  var _document$body$getBou = document.body.getBoundingClientRect(),
      width = _document$body$getBou.width;
  /** Apply or remove overflow style */


  if (preventScroll) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = previousOverflow || '';
  }
  /** Get the _new width_ of the body (this will tell us the scrollbar width) */


  var newWidth = document.body.getBoundingClientRect().width;
  var scrollBarWidth = newWidth - width;
  /** If there's a diff due to scrollbars, then account for it with padding */

  if (preventScroll) {
    previousPaddingRight = document.body.style.paddingRight;
    document.body.style.paddingRight = "".concat(Math.max(0, scrollBarWidth || 0), "px");
  } else {
    document.body.style.paddingRight = previousPaddingRight || '';
  }
}

var zIndex = {
  TOAST: '100',
  OVERLAY: '20',
  POPUP_MENU: '100'
};

var Overlay = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
      containerSx = _ref.containerSx,
      preventBodyScrolling = _ref.preventBodyScrolling,
      shouldCloseOnBackdropClick = _ref.shouldCloseOnBackdropClick,
      shouldCloseOnEscapePress = _ref.shouldCloseOnEscapePress,
      handleClose = _ref.handleClose;

  var close = function close() {
    safeInvoke(handleClose);
  };

  var onEsc = function onEsc(event) {
    if (event.key === 'Escape' && shouldCloseOnEscapePress) {
      close();
    }
  };

  var handleBodyScroll = function handleBodyScroll(preventScroll) {
    if (preventBodyScrolling) {
      preventBodyScroll(preventScroll);
    }
  };

  useEffect(function () {
    handleBodyScroll(true); // TODO: bringFocusInside()

    document.body.addEventListener('keydown', onEsc, false);
    return function () {
      // Allow body to scroll and remove event listeners when component is unmounted
      handleBodyScroll(false); // TODO: bringFocusOutside()

      document.body.removeEventListener('keydown', onEsc, false);
    };
  }, []);

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget || !shouldCloseOnBackdropClick) {
      return;
    }

    close();
  };

  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Box, {
    id: "overlay-background",
    onClick: handleBackdropClick,
    sx: _objectSpread2({
      position: 'fixed',
      zIndex: zIndex.OVERLAY,
      top: 0,
      left: 0,
      // default overlay
      display: 'block',
      width: '100%',
      height: '100%',
      // background color
      bg: 'background.overlay'
    }, containerSx)
  }, children));
});
Overlay.propTypes = {
  /**
   * Children are react nodes
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * Styling passed to the background box.
   */
  containerSx: PropTypes.shape(),

  /**
   * Whether or not to prevent body scrolling outside the context of the overlay
   */
  preventBodyScrolling: PropTypes.bool,

  /**
   * Boolean indicating if clicking the overlay should close the overlay.
   */
  shouldCloseOnBackdropClick: PropTypes.bool,

  /**
   * Boolean indicating if pressing the esc key should close the overlay.
   */
  shouldCloseOnEscapePress: PropTypes.bool,

  /**
   * Function to be called when background or escape key is clicked
   */
  handleClose: PropTypes.func.isRequired
};
Overlay.defaultProps = {
  containerSx: {},
  preventBodyScrolling: true,
  shouldCloseOnBackdropClick: true,
  shouldCloseOnEscapePress: true
};

var _excluded$6 = ["as", "type", "variant", "boldVariant", "italicVariant", "maxchar", "children"];
/*
// Props
// type: lookup key for the theme.
//       Can be either full themeKey e.g. `smallParagraph` or short version
//       without appended "Paragraph": e.g. `small`
// as: html element to use. Defaults to `p`.
// maxchar: Maximum number of chars to display.
//          Will cut off after specified numner and append `...`
// variant: Font variant as specified in fontFamilies.js
//          Defaults to `normal`. Could be e.g. `bold`,...
// boldVariant: Typography variant  to be used for the bold styling
//              defaults to '<type>.bold'
// italicVariant: Typography variant  to be used for the italic styling
//              defaults to '<type>.italic'
*/

var Paragraph = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
      type = _ref.type,
      variant = _ref.variant,
      boldVariant = _ref.boldVariant,
      italicVariant = _ref.italicVariant,
      maxchar = _ref.maxchar,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$6);

  // const { theme } = useThemeUI();
  // allows us to only specify `type=loud` but actually lookup loudParagraph in typographySetup.js
  // const fullType = theme?.typography?.[type] ? type : `${type}Paragraph`;
  var fullType = type;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: as ? motion[as] : motion.p,
    variant: variant,
    __themeKey: "typography.".concat(fullType)
  }, props, {
    __css: {
      color: 'text'
    }
  }), children && /*#__PURE__*/React.createElement(RichText, {
    maxchar: maxchar,
    content: children,
    Bold: function Bold(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement(Emphasize, {
        color: "textBold",
        variant: boldVariant || "".concat(fullType, ".bold")
      }, children);
    },
    Italic: function Italic(_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/React.createElement(Emphasize, {
        color: "textItalic",
        variant: italicVariant || "".concat(fullType, ".italic")
      }, children);
    }
  }));
});
Paragraph.propTypes = {
  as: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string,
  boldVariant: PropTypes.string,
  italicVariant: PropTypes.string,
  maxchar: PropTypes.string,
  children: PropTypes.node
};
Paragraph.defaultProps = {
  as: undefined,
  type: 'paragraph',
  variant: 'normal',
  boldVariant: undefined,
  italicVariant: undefined,
  maxchar: undefined,
  children: undefined
};

var _excluded$5 = ["sx"];
var Image = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    as: motion.img
  }, props, {
    sx: _objectSpread2({
      width: '100%',
      zIndex: 'inherit'
    }, sx)
  }));
});
Image.propTypes = {
  sx: PropTypes.shape()
};
Image.defaultProps = {
  sx: {}
};

var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: "card--background",
    ref: ref,
    variant: "primary"
  }, props, {
    __themeKey: "cards",
    __css: {
      backgroundColor: '#fff'
    }
  }));
});

var _excluded$4 = ["devices", "sx"];
var defaultStyles = {
  bg: "secondary",
  position: "absolute",
  height: "100%",
  zIndex: 0,
  top: 0
};
var FullWidthBackground = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var devices = _ref.devices,
      sx = _ref.sx,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var showBackground = devices.map(function (device) {
    if (device === "full") {
      return "measure.fullWidth";
    }

    return "measure.gridColumnFallback";
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: "fullwidth-background",
    ref: ref,
    sx: _objectSpread2(_objectSpread2({
      variant: showBackground
    }, defaultStyles), sx)
  }, props));
});
FullWidthBackground.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.oneOf(["full", null]).isRequired).isRequired,
  sx: PropTypes.object
};
FullWidthBackground.defaultProps = {
  sx: {}
};

// external dependencies
var Divider = function Divider(_ref) {
  var sx = _ref.sx;
  return /*#__PURE__*/React.createElement(Box, {
    sx: sx
  });
};
Divider.propTypes = {
  sx: PropTypes.shape()
};
Divider.defaultProps = {
  sx: {}
};

var _excluded$3 = ["variant"];
var TextArea = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    variant: variant,
    as: motion.textarea
  }, props, {
    __themeKey: "forms",
    __css: {
      boxSizing: "border-box",
      display: "block",
      width: "100%",
      appearance: "none",
      border: "inherit"
    }
  }));
});
TextArea.propTypes = {
  variant: PropTypes.string
};
TextArea.defaultProps = {
  variant: "textarea"
};

/* eslint-disable max-len */
var breakpoints = [// Portrait - is added by theme-ui automatically
// '@media screen and (min-width: 20em)', // 320px phone_portrait
// Small
'@media screen and (min-width: 500px)', // Medium
'@media screen and (min-width: 750px) and (orientation: portrait)', '@media screen and (min-width: 700px) and (orientation: landscape)', // Large
'@media screen and (min-width: 1000px)', // Xlarge
'@media screen and (min-width: 1400px)'];
var pixelValues = [320, 500, 750, 700, 1000, 1400];
var srcsetValues = ['(min-width: 500px)', '(min-width: 750px) and (orientation: portrait)', '(min-width: 700px) and (orientation: landscape)', '(min-width: 1000px)', '(min-width: 1400px)'];

var _excluded$2 = ["images"];

var ResponsiveImage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var images = _ref.images,
      props = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement(Box, _extends({
    className: "hello",
    ref: ref,
    as: motion.picture
  }, props), /*#__PURE__*/React.createElement("source", {
    srcSet: images[5],
    media: srcsetValues[4]
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: images[4],
    media: srcsetValues[3]
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: images[3],
    media: srcsetValues[2]
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: images[2],
    media: srcsetValues[1]
  }), /*#__PURE__*/React.createElement("source", {
    srcSet: images[1],
    media: srcsetValues[0]
  }), /*#__PURE__*/React.createElement("img", {
    src: images[0],
    alt: ""
  }));
});
ResponsiveImage.propTypes = {
  images: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired
};

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var TabsContext = /*#__PURE__*/createContext();

var useTabsContext = function useTabsContext() {
  return useContext(TabsContext);
};

var TabsProvider = function TabsProvider(_ref) {
  var initialActiveTab = _ref.activeTab,
      children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tabs = _useState2[0],
      setTabs = _useState2[1];

  var _useState3 = useState(initialActiveTab),
      _useState4 = _slicedToArray(_useState3, 2),
      activeTab = _useState4[0],
      setActiveTab = _useState4[1];

  var registerTab = function registerTab(newTab) {
    var isNewTabFound;
    tabs.forEach(function (tab) {
      if (tab.id === newTab.id) {
        isNewTabFound = true;
      }
    });

    if (!isNewTabFound) {
      setTabs(function (previousTabs) {
        return [].concat(_toConsumableArray(previousTabs), [newTab]);
      });
    }
  };

  var onClick = function onClick(tab) {
    return function () {
      setActiveTab(tab);
    };
  };

  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: {
      tabs: tabs,
      activeTab: activeTab,
      registerTab: registerTab,
      onClick: onClick
    }
  }, children);
};

TabsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  activeTab: PropTypes.number.isRequired
};

var Tab = function Tab(_ref) {
  var id = _ref.id,
      title = _ref.title,
      children = _ref.children;

  var _useTabsContext = useTabsContext(),
      registerTab = _useTabsContext.registerTab,
      activeTab = _useTabsContext.activeTab;

  useEffect(function () {
    registerTab({
      id: id,
      title: title
    });
  }, []);
  return (
    /*#__PURE__*/
    // Only return content if tab is active
    React.createElement(React.Fragment, null, (activeTab === null || activeTab === void 0 ? void 0 : activeTab.id) === id && children)
  );
};
Tab.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

var _excluded$1 = ["activeTab"];

function withTabsContext(Component) {
  var withTabsContextFunc = function withTabsContextFunc(_ref) {
    var activeTab = _ref.activeTab,
        props = _objectWithoutProperties(_ref, _excluded$1);

    return /*#__PURE__*/React.createElement(TabsProvider, {
      activeTab: activeTab
    }, /*#__PURE__*/React.createElement(Component, props));
  };

  return withTabsContextFunc;
}

// external dependencies

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      _ref$Tab = _ref.Tab,
      Tab = _ref$Tab === void 0 ? Box : _ref$Tab,
      _ref$TabContainer = _ref.TabContainer,
      TabContainer = _ref$TabContainer === void 0 ? FlexWrapper : _ref$TabContainer;

  var _useTabsContext = useTabsContext(),
      tabs = _useTabsContext.tabs,
      activeTab = _useTabsContext.activeTab,
      onClick = _useTabsContext.onClick;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContainer, {
    sx: {
      alignItems: 'flex-end'
    }
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tab, {
      onClick: onClick(tab),
      key: tab.id,
      id: tab.id,
      isActive: (activeTab === null || activeTab === void 0 ? void 0 : activeTab.id) === tab.id
    }, tab.title);
  })), children);
};

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Tab: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  TabContainer: PropTypes.object
};
Tabs.defaultProps = {
  Tab: Box,
  TabContainer: FlexWrapper
};
var TabsWithContext = withTabsContext(Tabs);

/* eslint-disable max-len */
var getFontSizes = function getFontSizes(_ref) {
  var factor = _ref.factor,
      sizes = _ref.sizes;
  var fontSizes = sizes.map(function (size, i) {
    return "calc(".concat(size, "px + ((100vw - ").concat(pixelValues[i], "px) * ").concat(size, " / ").concat(factor, " / ").concat(pixelValues[i], "))");
  });
  return fontSizes;
};

var _excluded = ["fontFamily", "lineHeight", "factor", "fontSizes"];
var getFluidTypographyStyles = (function (_ref) {
  var typographyConfig = _ref.typographyConfig,
      fontFamilies = _ref.fontFamilies;
  // return all of the variants for the client theme
  var typography = {}; // type = each HTML tag within the setup e.g h1

  Object.keys(typographyConfig).forEach(function (type) {
    // will hold the different variants for normal, bold, italic...
    typography[type] = {}; // fontFamilies will give us the actual 'weight' for each style
    // fontFamilies also tell us what kind of 'weights' are requested

    Object.keys(fontFamilies[typographyConfig[type].fontFamily]).forEach(function (family) {
      var _typographyConfig$typ = typographyConfig[type],
          fontFamily = _typographyConfig$typ.fontFamily,
          lineHeight = _typographyConfig$typ.lineHeight,
          _typographyConfig$typ2 = _typographyConfig$typ.factor,
          factor = _typographyConfig$typ2 === void 0 ? 2.5 : _typographyConfig$typ2,
          fontSizes = _typographyConfig$typ.fontSizes,
          rest = _objectWithoutProperties(_typographyConfig$typ, _excluded); // computing e.g typography.h1.bold


      typography[type][family] = _objectSpread2({
        fontFamily: fontFamilies[fontFamily][family],
        lineHeight: lineHeight,
        fontSize: getFontSizes({
          factor: factor,
          sizes: fontSizes
        })
      }, rest);
    });
  });
  return typography;
});

/* eslint-disable max-len */

var getGridPadding = function getGridPadding(_ref) {
  var offset = _ref.offset,
      pixelValue = _ref.pixelValue,
      factor = _ref.factor;
  return "calc(".concat(offset, "px + ((100vw - (").concat(pixelValue, "px + (100vw - ").concat(pixelValue, "px) / ").concat(factor, ")) / 2))");
};

var getGridPaddings = function getGridPaddings(_ref2) {
  var factor = _ref2.factor,
      offsets = _ref2.offsets;
  var paddings = offsets.map(function (offset, i) {
    return "0 ".concat(getGridPadding({
      offset: offset,
      factor: factor[i],
      pixelValue: pixelValues[i]
    }));
  });
  return paddings;
};
var getFullWidthItemMinusMargin = function getFullWidthItemMinusMargin(_ref3) {
  var factor = _ref3.factor,
      offsets = _ref3.offsets;
  var leftMinusMargins = offsets.map(function (offset, i) {
    return "calc(-1 * ".concat(getGridPadding({
      offset: offset,
      factor: factor[i],
      pixelValue: pixelValues[i]
    }), ")");
  });
  return leftMinusMargins;
};

/* eslint-disable max-len */
var getGridTemplateColumns = function getGridTemplateColumns(_ref) {
  var totalColumsPerBreakpoint = _ref.totalColumsPerBreakpoint,
      offsets = _ref.offsets,
      gaps = _ref.gaps,
      factor = _ref.factor;
  var templateColumns = totalColumsPerBreakpoint.map(function (columns, index) {
    return "repeat(".concat(columns, ", \n  calc(\n    (\n      (\n          100vw -\n            (2 * (").concat(offsets[index], "px + ((100vw - (").concat(pixelValues[index], "px + (100vw - ").concat(pixelValues[index], "px) / ").concat(factor[index], ")) / 2))) -\n            (").concat(columns - 1, " * ").concat(gaps[index], ")\n        ) / ").concat(columns, "\n    )\n  ))");
  });
  return templateColumns;
};

/* eslint-disable max-len */
var getGridAutoLayout = function getGridAutoLayout(_ref) {
  var totalColumsPerBreakpoint = _ref.totalColumsPerBreakpoint,
      offsets = _ref.offsets,
      gaps = _ref.gaps,
      factor = _ref.factor;
  var autoLayout = totalColumsPerBreakpoint.map(function (columns, index) {
    return "\n  calc(\n    (\n      (\n          100vw -\n            (2 * (".concat(offsets[index], "px + ((100vw - (").concat(pixelValues[index], "px + (100vw - ").concat(pixelValues[index], "px) / ").concat(factor[index], ")) / 2))) -\n            (").concat(columns - 1, " * ").concat(gaps[index], ")\n        ) / ").concat(columns, "\n    )\n  )");
  });
  return autoLayout;
};

var factor = [2.5, 2.5, 2.5, 2.5, 2.5, 2.5];
var offsets = [11.5, 20, 38, 28, 39, 68];
var gaps = ['1.35vw', '1.5vw', '1.5vw', '.96vw', '.67vw', '1.1vw'];
var proportionalPaddings = getGridPaddings({
  factor: factor,
  offsets: offsets
});
var templateColumns = getGridTemplateColumns({
  totalColumsPerBreakpoint: [12, 12, 24, 24, 24, 24],
  factor: factor,
  offsets: offsets,
  gaps: gaps
});
var autoLayout = getGridAutoLayout({
  totalColumsPerBreakpoint: [12, 12, 24, 24, 24, 24],
  factor: factor,
  offsets: offsets,
  gaps: gaps
}); // Grid templates

var columns = {
  gridColumnGap: gaps,
  gridTemplateColumns: templateColumns
};
var autoColumns = {
  gridColumnGap: gaps,
  gridAutoColumns: autoLayout
};
var autoColumnsAndRows = {
  gridRowGap: gaps,
  gridColumnGap: gaps,
  gridAutoRows: autoLayout,
  gridAutoColumns: autoLayout
};
var fullWidthMinusMargins = getFullWidthItemMinusMargin({
  factor: factor,
  offsets: offsets
});
var grids = {
  // Proportional grids for outter-wrapper including padding
  outside: {
    columns: _objectSpread2(_objectSpread2({}, columns), {}, {
      padding: proportionalPaddings
    }),
    autoColumns: _objectSpread2(_objectSpread2({}, autoColumns), {}, {
      padding: proportionalPaddings
    }),
    autoColumnsAndRows: _objectSpread2(_objectSpread2({}, autoColumnsAndRows), {}, {
      padding: proportionalPaddings,
      gridAutoRows: autoLayout,
      gridAutoColumns: autoLayout
    })
  },
  // Proportional grids for inner-wrapper without padding
  inside: {
    columns: _objectSpread2(_objectSpread2({}, columns), {}, {
      padding: 0
    }),
    autoColumns: _objectSpread2(_objectSpread2({}, autoColumns), {}, {
      padding: 0
    }),
    autoColumnsAndRows: _objectSpread2(_objectSpread2({}, autoColumnsAndRows), {}, {
      padding: 0
    })
  }
};

var measure = {
  // fallback will force the gridItem to expand across the full width of the gridWrapper
  gridColumnFallback: {
    marginLeft: 'unset',
    marginRight: 'unset',
    gridColumn: ['1/13', '1/13', '1/25', '1/25', '1/25']
  },
  // Minus margin, to allow Grid Items inside of a proportional grid to be full width
  // use it on GridItem via the variant prop like so:
  // `variant="fullWidth"`
  fullWidth: {
    marginRight: fullWidthMinusMargins,
    marginLeft: fullWidthMinusMargins
  }
};

var theme = {
  breakpoints: breakpoints,
  grids: grids,
  measure: measure,
  colors: {
    text: '#000',
    background: '#fff',
    primary: '#33e'
  },
  cards: {
    primary: {
      bg: 'red'
    }
  },
  styles: {
    root: {
      fontFamily: 'body.normal',
      color: 'text',
      bg: 'background'
    }
  }
};

export { Block, Box, Button, Card, Divider, Emphasize, FlexItem, FlexWrapper, FormField, FullWidthBackground, GridItem, GridWrapper, Heading, Image, Input, Label, Link, Overlay, Paragraph, Portal, ResponsiveImage, Section, Tab, TabsWithContext as Tabs, TextArea, breakpoints, fullWidthMinusMargins, getFluidTypographyStyles, pixelValues, preventBodyScroll, srcsetValues, theme };
